import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="max-w-3xl mx-auto px-8 py-12 animate-fade-in" data-testid="dashboard-page">
      {/* Welcome */}
      <div className="mb-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Welcome to the Bonus Materials Hub
        </h1>
        <p className="text-gray-500 text-lg leading-relaxed">
          Access your exclusive companion resources for <em>Untangling AI</em> by Matt Kesby. 
          Select a chapter from the sidebar to begin exploring.
        </p>
      </div>

      {/* Book info card */}
      <div className="bg-[#F5C518] rounded-xl p-8 mb-10 flex items-center gap-8" data-testid="welcome-card">
        <div className="shrink-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_requirement-app-4/artifacts/ebglgl95_Untangling%20AI%20-%20Matt%20Kesby.jpeg" 
            alt="Untangling AI Book Cover" 
            className="w-36 h-auto rounded-lg shadow-lg"
            data-testid="book-cover"
          />
        </div>
        <div>
          <h2 className="text-xl font-bold text-black mb-2">Untangling AI</h2>
          <p className="text-black/70 text-sm leading-relaxed mb-4">
            Driving Business Success Through Enterprise Automation and AI Agents
          </p>
          <p className="text-black/60 text-xs font-medium">By Matt Kesby | Published by Wiley</p>
        </div>
      </div>

      {/* Quick start */}
      <div className="mb-8">
        <h2 className="text-lg font-bold text-gray-900 mb-4">Quick Start</h2>
        <p className="text-gray-500 text-sm mb-4">
          Use the sidebar navigation to browse chapters and their bonus resources. Click any resource to view its content, embedded videos, links, and downloadable materials.
        </p>
      </div>

      {/* How it works */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {[
          { step: '1', title: 'Browse Chapters', desc: 'Expand chapters in the sidebar to see all available bonus materials' },
          { step: '2', title: 'Explore Resources', desc: 'Click a resource to view videos, templates, tools, and guides' },
          { step: '3', title: 'Track Progress', desc: 'Mark resources complete as you work through the materials' },
        ].map(item => (
          <div key={item.step} className="border border-gray-200 rounded-xl p-5">
            <div className="w-8 h-8 rounded-full bg-[#F5C518] flex items-center justify-center text-black font-bold text-sm mb-3">{item.step}</div>
            <h3 className="text-sm font-semibold text-gray-900 mb-1">{item.title}</h3>
            <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
